import React, { useState } from "react"
import { Button, Menu, makeStyles, MenuItem, ListItemIcon, Box } from "@material-ui/core"
import { SpeedDialAction } from "@material-ui/lab"
import { RequirePermissions, FloatingSpeedDial, Icon } from ".."
import { useAuth } from "../../services"

const useStyles = makeStyles((theme) => ({
  menu: {
    marginTop: 50,
  },
  menuListItemIcon: {
    minWidth: "auto",
    paddingRight: theme.spacing(2),
  },
}))

const useSpeedDialActionStyles = makeStyles(() => ({
  staticTooltipLabel: {
    whiteSpace: "nowrap",
  },
}))

const DesktopCreateJobButton = ({ onCreateClick, isTemplates }) => {
  const classes = useStyles()
  const { permissionGroups, hasFeature } = useAuth()
  const [showCreateOptions, setShowCreateOptions] = useState(false)
  const [showCreateOptionsEl, setShowCreateOptionsEl] = useState(null)

  const hasProcessSingleStep = isTemplates && hasFeature("process_single_step")

  const handleCreateClick = (type) => {
    setShowCreateOptions(false)
    setShowCreateOptionsEl(null)
    onCreateClick(type)
  }

  const handleToggleCreateMenu = ({ currentTarget }) => {
    if (hasProcessSingleStep) {
      handleCreateClick("process")
      return
    }

    setShowCreateOptionsEl(!showCreateOptions ? currentTarget : null)
    setShowCreateOptions(!showCreateOptions)
  }

  return (
    <RequirePermissions requires={permissionGroups.createJobs}>
      <Box display="flex" flexDirection="row">
        {!isTemplates && (
          <Box mr={1}>
            <Button id="runadhoc" onClick={() => handleCreateClick("adhoc")} variant="contained" color="primary">
              Run ad hoc process
            </Button>
          </Box>
        )}
        {isTemplates && (
          <RequirePermissions requires={["process_create"]}>
            <Button onClick={handleToggleCreateMenu} variant="contained" color="primary" data-cy="Button-create-job">
              Create job
            </Button>
            <Menu
              anchorEl={showCreateOptionsEl}
              keepMounted
              open={showCreateOptions}
              onClose={handleToggleCreateMenu}
              className={classes.menu}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem onClick={() => handleCreateClick("process")} data-cy="MenuItem-create-process">
                <ListItemIcon className={classes.menuListItemIcon}>
                  <Icon name="process" />
                </ListItemIcon>
                <>Create a process</>
              </MenuItem>
              <MenuItem onClick={() => handleCreateClick("task")} data-cy="MenuItem-create-task">
                <ListItemIcon className={classes.menuListItemIcon}>
                  <Icon name="task" />
                </ListItemIcon>
                <>Create a single task</>
              </MenuItem>
            </Menu>
          </RequirePermissions>
        )}
      </Box>
    </RequirePermissions>
  )
}

const MobileCreateJobButton = ({ onCreateClick, isTemplates }) => {
  const classes = useSpeedDialActionStyles()
  const { permissionGroups, hasFeature } = useAuth()
  const [openSpeedDial, setOpenSpeedDial] = useState(false)

  const hasProcessSingleStep = isTemplates && hasFeature("process_single_step")

  const handleCreateClick = (type) => {
    handleToggleSpeedDial()
    onCreateClick(type)
  }

  const handleToggleSpeedDial = () => {
    if (hasProcessSingleStep) {
      onCreateClick("process")
      return
    }

    setOpenSpeedDial(!openSpeedDial)
  }

  return (
    <RequirePermissions requires={permissionGroups.createJobs}>
      <FloatingSpeedDial onClose={handleToggleSpeedDial} onOpen={handleToggleSpeedDial} open={openSpeedDial}>
        {isTemplates && (
          <SpeedDialAction
            tooltipTitle="Create a new process"
            icon={<Icon name="process" />}
            tooltipOpen
            onClick={() => handleCreateClick("process")}
            classes={classes}
          />
        )}
        {isTemplates && (
          <SpeedDialAction
            tooltipTitle="Create a new task"
            icon={<Icon name="task" />}
            tooltipOpen
            onClick={() => handleCreateClick("task")}
            classes={classes}
          />
        )}
        {!isTemplates && (
          <SpeedDialAction
            tooltipTitle=" Run ad hoc process"
            icon={<Icon name="form" />}
            tooltipOpen
            onClick={() => handleCreateClick("adhoc")}
            classes={classes}
          />
        )}
      </FloatingSpeedDial>
    </RequirePermissions>
  )
}

export { DesktopCreateJobButton, MobileCreateJobButton }
